import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'components/layout';
import { Box, Typography, Grid } from '@mui/material';

const WorkflowAbout = ({
  methods,
  policies,
  fieldData,
  projects,
  isLoaded,
  showActions = true,
  isEdit = false
}) => {
  const [t] = useTranslation();
  const { control, getValues } = methods;
  const getProjectName = (id) => {
    if (!id) return '';
    const project = projects.find(p => p.value === id);
    return project.label;
  }

  const fields = [
    { policy: policies.name, value: getValues(policies.name.name) },
    { policy: policies.description, value: getValues(policies.description.name) },
    { policy: {...policies.project, disabled: true}, options: projects, value: getProjectName(getValues(policies.project.name)) },
  ];

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Typography variant="h6" sx={{ padding: '8px 0px' }}>
        {t('workflowList.stepper.about.title')}
      </Typography>
      {showActions ?
        (
          <Grid container spacing={2}>
            {fields.map((field) => (
              <Grid item xs={12} sm={6} md={4} lg={4} key={field.policy.id}>
                <Input
                  {...field.policy}
                  control={control}
                  options={field.options}
                  sx={{ width: '100%' }}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container spacing={2}>
            {fields.map((field) => (
              <Grid key={field.policy.id} item xs={12} sm={12} md={6} lg={4}>
                <Typography variant="subtitle1">
                  {t(field.policy.label)}
                </Typography>
                <Typography variant="body1">
                  {field.value}
                </Typography>
              </Grid>
            ))}
          </Grid>
        )
      }
    </Box>
  );
};

export default WorkflowAbout;
